import { formatJobType, jobStatusLabel } from './jobStatus';

export type JobsDashboardFilterState = {
  typeFilter: string;
  statusFilter: string;
  searchIdFilter: string;
  subscriptionIdFilter: string;
};

export function jobsDashboardHasFilters(filters: JobsDashboardFilterState): boolean {
  return Boolean(
    filters.typeFilter ||
      filters.statusFilter ||
      filters.searchIdFilter ||
      filters.subscriptionIdFilter
  );
}

export function describeJobsDashboardFilters(filters: JobsDashboardFilterState): string[] {
  const labels: string[] = [];
  if (filters.typeFilter) {
    labels.push(`Type: ${formatJobType(filters.typeFilter)}`);
  }
  if (filters.statusFilter) {
    labels.push(`Status: ${jobStatusLabel(filters.statusFilter)}`);
  }
  if (filters.searchIdFilter) {
    labels.push(`Search ID: ${filters.searchIdFilter}`);
  }
  if (filters.subscriptionIdFilter) {
    labels.push(`Subscription ID: ${filters.subscriptionIdFilter}`);
  }
  return labels;
}
